import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ArgusIntegrationService } from 'src/app/services/ArgusIntegrationService';
import { ArgusSyncOptionEnum } from '../../models/enums/argus-sync-option.enum';
import { RaciService } from '../../modules/raci/services/raci.service';
import { ModulesEnum, RaciTabs } from '../enum';
import { NavigationActionBase } from '../navigation-action-base';
import { NavigationService } from '../navigation.service';
import { RaciNavigationService } from '../raci-navigation.service';
import { EventBusService } from '../../services/event-bus.service';
import { AppStorageService } from '../../services/app-storage.service';
/**
 * Raci navigation component
 */
@Component({
  selector: 'raci-navigation',
  templateUrl: './raci-navigation.component.html',
  styleUrls: ['../top-main-navigation/top-main-navigation.component.css', '../raci-navigation/raci-navigation.component.css']
})
export class RaciNavigationComponent extends NavigationActionBase implements OnInit {
  /**
   * Change detector reference
   */
  _ref: ChangeDetectorRef;
  /**
   * navigation service
   */
  _navigationService: NavigationService;
  /**
   * Raci navigation service
   */
  _raciNavigationService: RaciNavigationService;
  /**
   * Participants section active
   */
  participantsSectionActive = false;
  /**
   * Current user
   */
  currentUser: any;
  /**
   * Active tab
   */
  activeTab: RaciTabs;
  /**
   * Group by
   */
  groupBy = "";
  /**
   * Should hide top navigation icons
   */
  shouldHideTopNavigationIcons = false;
  /**
   * Should show history icon
   */
  shouldShowHistoryIcon = false;
  /**
   * should hide top navigation user dashboard icons
   */
  shouldHideTopNavigationUserDashboardIcons = true;
  /**
   * Show preview portfolio
   */
  showPreviewPortfolio = false;
  /**
   * Is row selected
   */
  isRowSelected = false;
  /**
   * Close approval proccess
   */
  closeApprovalProccess = false;
  /**
   * Is approval history active
   */
  isApprovalHistoryActive = false;
  /**
   * Is valuation events active
   */
  isValuationEventsActive = true;
  /**
   * Show approve icon
   */
  showApproveIcon = false;
  /**
   * Is approval clicked
   */
  isApprovalClicked = false;
  /**
   * Show publish to valorem icon
   */
  showPublishToValoremIcon = false;
  /**
   * Show sync with argus icon
   */
  showSyncWithArgus = false;
  /**
   * Should sync with argus
   */
  shouldSyncWithArgus = false;
  /**
   * Is publish to valorem displayed
   */
  isPublishToValoremDisplayed = false;
  /**
   * Is publish to valorem icon displayed
   */
  isPublishToValoremIconDisplayed = false;
  /**
   * Show sync portfolio with argus icon
   */
  showSyncPortfolioWithArgusIcon: boolean;
  /**
   * Show save approval icon
   */
  showSaveApprovalIcon = false;
  /**
   * Show task approval history icon
   */
  showTaskApprovalHistoryIcon = false;
  /**
   * Is task approval history displayed
   */
  isTaskApprovalHistoryDisplayed = false;
  /**
   * Show setup valuation event save icon
   */
  showSetupValuationEventSaveIcon = false;
  /**
   * Show setup valuation effective dates save icon
   */
  showSetupValuationEffectiveDatesSaveIcon = false;
  /**
   * Is project closed
   */
  isProjectClosed = false;

  /**
   * Is approve/reject dialog displayed
   */
  isApproveDialogDisplayed = false;

  /**
   * Constructor
   * @param appStorage AppStorageService
   * @param ref ChangeDetectorRef
   * @param navigationService NavigationService
   * @param eventBus EventBusService
   * @param raciNavigationService RaciNavigationService
   * @param _argusIntegrationService ArgusIntegrationService
   * @param translate TranslateService
   * @param raciService RaciService
   */
  constructor(appStorage: AppStorageService,
    ref: ChangeDetectorRef,
    navigationService: NavigationService,
    eventBus: EventBusService,
    raciNavigationService: RaciNavigationService,
    private _argusIntegrationService: ArgusIntegrationService,
    private translate: TranslateService,
    private raciService: RaciService) {
    super(appStorage, eventBus, ref, navigationService);
    this._ref = ref;
    this._navigationService = navigationService;
    this._raciNavigationService = raciNavigationService;
  }
  /**
   * Initializes the component
   */
  ngOnInit(): void {
    super.ngOnInit();

    this.currentUser = this.appStorage.getCurrentUserDetails();
    this.activeTab = this._navigationService.getActiveRaciTab();

    this.onEvents.push(this.eventBus.subscribeEvent("raci:shouldShowConfirmDialog", (showConfirmDialog, _options) => {
      if (!showConfirmDialog) {
        this.setActiveRaciTab(RaciTabs.UserDashboard)
        this._ref.markForCheck();
      }
      else if (showConfirmDialog) {
        this.setActiveRaciTab(RaciTabs.Overview);
        this.eventBus.broadcastEvent("openConfirmDialog", {
          success: () => {
            //Nothing
          }
        }, 'saveApproval');
      }
    }));

    this.subscriptions.add(this._raciNavigationService._onHideTopNavigationIcons.subscribe(value => {
      this.shouldHideTopNavigationIcons = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._onDisplayApprovalHistoryIcon.subscribe(data => {
      this.shouldShowHistoryIcon = data;
      this.isApprovalHistoryActive = false;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._onHideTopNavigationUserDashboardIcons.subscribe(value => {
      this.shouldHideTopNavigationUserDashboardIcons = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._updatePublishToValoremActiveStatus.subscribe(value => {
      this.isPublishToValoremDisplayed = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._updateSyncWithArgusActiveStatus.subscribe(value => {
      this.shouldSyncWithArgus = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._selectRow.subscribe(value => {
      this.isRowSelected = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._showPreviewPortfolioIcon.subscribe(value => {
      this.showApproveIcon = value;
      this._ref.markForCheck();
    }))

    this.subscriptions.add(this._raciNavigationService._showApproveIcon.subscribe(value => {
      this.showApproveIcon = value;
      this._ref.markForCheck();
    }))

    this._raciNavigationService._closeRaci.subscribe(data => {
      if (this.closeApprovalProccess) {
        if (data) {
          this.eventBus.broadcastEvent("openConfirmDialog", {
            success: () => {
              this.onCancel();
              this.closeApprovalProccess = false;
            },
            cancel: () => {
              //Nothing
            },
          }, 'closeParticipantAssignment');
        } else {
          this.onCancel();
          this.closeApprovalProccess = false;
        }
      }
      this.participantsSectionActive = false;
    })

    this.subscriptions.add(this._raciNavigationService._showSyncWithArgus.subscribe(data => {
      this.showSyncWithArgus = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._syncPortfolioWithArgus.subscribe(data => {
      this.showSyncPortfolioWithArgusIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._syncPortfolioWithVaorem.subscribe(data => {
      this.showPublishToValoremIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showSaveApprovalIcon.subscribe(data => {
      this.showSaveApprovalIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showTaskApprovalHistoryIcon.subscribe(data => {
      this.showTaskApprovalHistoryIcon = data;
      this.isTaskApprovalHistoryDisplayed = false;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showSetupValuationEventSaveIcon.subscribe(data => {
      this.showSetupValuationEventSaveIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._showSetupValuationEffectiveDatesSaveIcon.subscribe(data => {
      this.showSetupValuationEffectiveDatesSaveIcon = data;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._onDisplayApprovalHistory.subscribe(value => {
      this.isApprovalHistoryActive = value;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._isProjectClosed.subscribe(value => {
      this.isProjectClosed = value;
      this._ref.markForCheck();
    }));

    this.subscriptions.add(this._raciNavigationService._isApprovalClicked.subscribe(value => {
      this.isApprovalClicked = value;
      this._ref.markForCheck();
    }));
  }

  /**
   * Updates approval history activity
   */
  updateApprovalHistory() {
    if (this.isValuationEventsActive) {
      this.valuationEventsClicked()
    }

    if (this.participantsSectionActive) {
      this.showRaciParticipantsSection()
    }

    this.isApprovalHistoryActive = !this.isApprovalHistoryActive;
    this._raciNavigationService.onDisplayApprovalHistory(this.isApprovalHistoryActive);
  }

  /**
   * Valuation events clicked
   */
  valuationEventsClicked() {
    if (this.isApprovalHistoryActive) {
      this.updateApprovalHistory()
    }

    if (this.participantsSectionActive) {
      this.showRaciParticipantsSection()
    }

    this.isValuationEventsActive = !this.isValuationEventsActive;
    this.eventBus.broadcastEvent("valuationEventsClicked");
  }

  /**
   * Show alert
   */
  showAlertTeamsChannel() {
    alert("Teams channel is not implemented yet, please open it in your teams to see documents related to this Portfolio.");
  }

  /**
   * Show Participants section on Overview tab
   */
  showRaciParticipantsSection() {
    if (this.isProjectClosed) return;

    if (this.isValuationEventsActive) {
      this.valuationEventsClicked()
    }

    if (this.isApprovalHistoryActive) {
      this.updateApprovalHistory()
    }

    this.participantsSectionActive = !this.participantsSectionActive;
    this._raciNavigationService.showRaciParticipantsSection(this.participantsSectionActive);
  }

  /**
   * Redirect to different raci tab
   * @param tab
   */
  setActiveRaciTab(tab) {
    this._raciNavigationService.onSelectRow(false);
    this.activeTab = tab;
    if (this.activeTab === RaciTabs.UserDashboard) {
      this.participantsSectionActive = false;
      this._raciNavigationService.showRaciParticipantsSection(this.participantsSectionActive);
      this.isRowSelected = false;
      this.showPreviewPortfolio = false;
      this.shouldHideTopNavigationUserDashboardIcons = true;
    }
    this.showTaskApprovalHistoryIcon = false;
    this.isTaskApprovalHistoryDisplayed = false;
    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(false);
    this._navigationService.setActiveRaciTab(tab);
  }

  /**
 * Gets the RaciTabs enum
 */
  public get raciTabs(): typeof RaciTabs {
    return RaciTabs;
  }

  /**
   * Updated group participants properties value
   * @param value Grouped value
   */
  updateGroupPortofolioProperties(value: string) {
    if (this.isProjectClosed) return;

    this._raciNavigationService.onShowApproveIcon(false);
    if (this.groupBy == value)
      this.groupBy = null;
    else
      this.groupBy = value;

    this._raciNavigationService.groupPortfolioProperties(this.groupBy);
  }

  /**
   * Emits save approval event
   */
  saveApprovalChanges() {
    if (this.isProjectClosed) return;

    this._raciNavigationService._onSaveApproval.next(true);
  }

  /**
   * Emit open report event
   */
  openReport() {
    this._raciNavigationService.openReport();
  }

  /**
   * Emit open preview dashboard
   */
  openPreviewDashboard() {
    this._raciNavigationService.openPreviewDashboard();
  }

  /**
   * Redirect to user dashboard
   */
  redirectToUserDashboard() {
    this.eventBus.broadcastEvent("raci:checkIfApprovalMatrixChanged");
  }

  /**
   * On cancel
   */
  onCancel() {
    this._raciNavigationService.onStepsResetShouldConfirmDialog(false);
    this._raciNavigationService.onHostResetShouldConfirmDialog(false);
    if (this.participantsSectionActive) {
      this.showRaciParticipantsSection();
    }
    this._navigationService.setActiveModule(ModulesEnum.ProjectValuation);
    this._raciNavigationService.onShowHideRaciModule(false);
  }

  /**
   * Close Approval procces
   */
  onBack() {
    this.closeApprovalProccess = true;
    sessionStorage.setItem('raciValuationBack', '1');
    this._raciNavigationService.onCloseRaci();
  }

  /**
   * On approve
   * @returns
   */
  onApprove() {
    if (this.isProjectClosed) return;

    this.isApproveDialogDisplayed = true;
    this._raciNavigationService.showApprovalMatrixDialog(this.isApproveDialogDisplayed);
    this.isApprovalClicked = true;
    this._raciNavigationService.isApprovalClicked(this.isApprovalClicked);
  }

  /**
   * On publish to valorem action
   */
  onPublishToValorem() {
    if (this.isProjectClosed) return;

    this._raciNavigationService.onUpdatePublishToValoremActiveStatus(!this.isPublishToValoremDisplayed);
    this._raciNavigationService.onDisplayPublishToValorem(true);
  }

  /*
   * Function that will be used for syncing with argus
   */
  syncWithArgus() {
    if (this.isProjectClosed) return;
    this._raciNavigationService.onUpdateSyncWithArgusActiveStatus(!this.shouldSyncWithArgus);
    this.eventBus.broadcastEvent("getDataFromArgusDialog");
  }

  /**
   * Sync portfolio with Argus
   */
  onSyncPortfolioWithArgus() {
    let argusDialogProcessed;
    const activePortfolio = this._raciNavigationService.getActivePortfolio();
    const argusRequest = {
      Oid: activePortfolio.oid,
      ProjectId: activePortfolio.projectId,
      ValuationPortfolioName: activePortfolio.valuationPortfolioName,
      Remark: activePortfolio.Remark,
      currencyDescription: activePortfolio.currencyDescription,
      unitOfLengthId: activePortfolio.unitOfLengthId,
      ArgusPortfolioId: activePortfolio.ArgusPortfolioId
    }
    this.eventBus.broadcastEvent("argusDialog", {
      success: (copyFromArgusValuationId: number = null) => {
        this.eventBus.broadcastEvent("dataLoader", {
          displayLoader: () => {
            return true;
          }
        });
        if (copyFromArgusValuationId) {
          copyArgusPortfolio(copyFromArgusValuationId);
        }
        else {
          createArgusPortfolio();
        }
        this._ref.markForCheck();
      },
      cancel: () => {
        // Nothing
      },
      dialogContent: () => { return this._raciNavigationService._argusSyncOption == ArgusSyncOptionEnum.CopyOfExistingValuation ? this.translate.instant('exportToArgusConfirmDialog.copyValuationsMessage') : this.translate.instant('exportToArgusConfirmDialog.message') },
      shouldShowCloseButton: () => {
        return false;
      }
    }, 'exportToArgusConfirmDialog');

    /**
     * Create an Argus portfolio
     */
    const createArgusPortfolio = () => {
      this._argusIntegrationService.createArgusPortfolio(argusRequest).subscribe(serializedData => {
        const data = JSON.parse(serializedData);
        this.eventBus.broadcastEvent("dataLoader", {
          displayLoader: () => {
            return false;
          }
        });
        if (data) {
          argusDialogProcessed = "";

          data?.argusPortfolioMessages.forEach(message => {
            argusDialogProcessed += message;
          });

          argusDialogProcessed += ' <br/> ';

          data?.argusPropertyMessages.forEach(message => {
            argusDialogProcessed += message;
          });

          argusDialogProcessed += ' <br/> All actions completed. You can close this window. <br/>';
          this.eventBus.broadcastEvent('argusIntegrationCompleted');
          this.eventBus.broadcastEvent("argusDialog", {
            success: () => {
              //Nothing
            },
            cancel: () => {
              //Nothing
            },
            dialogContent: () => {
              return argusDialogProcessed;
            },
            shouldShowCloseButton: () => {
              return true;
            }
          }, 'exportToArgusConfirmDialog');
        }
        else {
          this.eventBus.broadcastEvent('argusIntegrationCompleted');
        }
        this._raciNavigationService.onRefreshTasks(true);
        this._raciNavigationService.onSyncPortfolioWithArgus(false, 0);
      });
    }

    /**
     * Copy an Argus portfolio
     * @param copyFromArgusValuationId
     */
    const copyArgusPortfolio = (copyFromArgusValuationId) => {
      this._argusIntegrationService.copyArgusValuation(copyFromArgusValuationId, argusRequest.Oid).subscribe(serializedData => {
        const data = JSON.parse(serializedData);
        this.eventBus.broadcastEvent("dataLoader", {
          displayLoader: () => {
            return false;
          }
        });
        if (data) {
          argusDialogProcessed = "";

          data?.argusPortfolioMessages.forEach(message => {
            argusDialogProcessed += message;
          });

          argusDialogProcessed += ' <br/> ';

          data?.argusPropertyMessages.forEach(message => {
            argusDialogProcessed += message;
          });

          argusDialogProcessed += ' <br/> All actions completed. You can close this window. <br/>';
          this.eventBus.broadcastEvent('argusIntegrationCompleted');
          this.eventBus.broadcastEvent("argusDialog", {
            success: () => {
              //Nothing
            },
            cancel: () => {
              //Nothing
            },
            dialogContent: () => {
              return argusDialogProcessed;
            },
            shouldShowCloseButton: () => {
              return true;
            }
          }, 'exportToArgusConfirmDialog');
        }
        else {
          this.eventBus.broadcastEvent('argusIntegrationCompleted');
        }
        this._raciNavigationService.onRefreshTasks(true);
        this._raciNavigationService.onSyncPortfolioWithArgus(false, 0);
      });
    }
  }

  /**
   * Confirm dialog for Valuation Event setup
   */
  openValuationEventSetupConfirmDialog() {
    if (this.isProjectClosed) return;

    this.eventBus.broadcastEvent("openConfirmDialog", {
      success: () => {
        this.saveValuationEventSetup();
      },
      cancel: () => {
        //Nothing
      }
    }, 'saveValuationEventSetupConfirmDialog');
  }

  /**
   * Save Valuation Event setup process
   */
  saveValuationEventSetup() {
    this.raciService.displayDataLoader(true);
    const activeValuationEventSetup = this._raciNavigationService.getActiveValuationEventSetup();
    this.raciService.saveVEBasicTaskDetails(activeValuationEventSetup).subscribe(data => {
      if (data) {
        this.raciService.displayDataLoader(false);
      }
    });
  }

  /**
   * Emit open approval history event
   */
  onDisplayTaskApprovalHistory() {
    if (this.isProjectClosed) return;

    this.isTaskApprovalHistoryDisplayed = !this.isTaskApprovalHistoryDisplayed;
    this._raciNavigationService.onDisplayTaskApprovalHistoryDialog(this.isTaskApprovalHistoryDisplayed);
  }

  /**
   * On save valuation effective dates 
   */
  saveValuationEffectiveDates() {
    this._raciNavigationService.onSaveEffectiveDates(true);
  }
}
